module.exports = __webpack_public_path__ + "img/icon-yard-sign.c45933ba.svg";